// extracted by mini-css-extract-plugin
module.exports = {"root":"navTrigger_root__3DshT"};